import accessibility from "./accessibility";
import cancellations from "./cancellations";
import complaints from "./complaints";
import cookies from "./cookies";
import faq from "./faq";
import finalSale from "./finalSale";
import intellectualProperty from "./intellectualProperty";
import international from "./international";
import packaging from "./packaging";
import parcelProblems from "./parcelProblems";
import payments from "./payments";
import privacy from "./privacy";
import productAccuracy from "./productAccuracy";
import promotions from "./promotions";
import returns from "./returns";
import reviewsContent from "./reviewsContent";
import safetyCare from "./safetyCare";
import shipping from "./shipping";
import terms from "./terms";
import updates from "./updates";
import workshops from "./workshops";

export const policyDocuments = [
  privacy,
  terms,
  shipping,
  parcelProblems,
  returns,
  cancellations,
  international,
  payments,
  promotions,
  finalSale,
  productAccuracy,
  safetyCare,
  reviewsContent,
  intellectualProperty,
  accessibility,
  packaging,
  complaints,
  updates,
  cookies,
  workshops,
  faq,
];

export const primaryPolicies = [privacy, terms, shipping, returns, faq, cookies];

export default policyDocuments;
